import { WelcomePage } from "../../components/WelcomePage";
import { ONBOARDING_STAGES } from "../../util/constants";
import { type OnboardingStepWrapperProps } from "../OnboardingStepWrapper";
import { useSaveOnboardingStageEffect } from "../useSaveOnboardingStageEffect";

export function WelcomeStep(props: Pick<OnboardingStepWrapperProps, "worker">) {
  const { worker } = props;

  useSaveOnboardingStageEffect({ worker, stage: ONBOARDING_STAGES.FINAL });

  return <WelcomePage />;
}
